<template>
  <div
    class="fixed z-[999] flex flex-col bg-white rounded-lg shadow-xl border border-gray-200 bottom-16 right-4 w-80 md:w-[460px] md:h-[calc(100vh-200px)] h-96 overflow-hidden transition-all duration-300"
  >
    <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100 bg-gradient-to-r from-primary-50 to-white">
      <div class="flex items-center gap-2">
        <div class="flex items-center justify-center w-8 h-8 rounded-full bg-primary-100">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-primary-600" viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 3H14C16.2091 3 18 4.79086 18 7V9.5C18 11.7091 16.2091 13.5 14 13.5H10C7.79086 13.5 6 11.7091 6 9.5V7C6 4.79086 7.79086 3 10 3ZM14 5H10C8.89543 5 8 5.89543 8 7V9.5C8 10.6046 8.89543 11.5 10 11.5H14C15.1046 11.5 16 10.6046 16 9.5V7C16 5.89543 15.1046 5 14 5ZM2 17.5C2 15.2909 3.79086 13.5 6 13.5H18C20.2091 13.5 22 15.2909 22 17.5V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V17.5ZM6 15.5C4.89543 15.5 4 16.3954 4 17.5V19H20V17.5C20 16.3954 19.1046 15.5 18 15.5H6Z"></path>
          </svg>
        </div>
        <h2 class="text-lg font-semibold text-gray-800">{{ $t('Help') }}</h2>
      </div>
      <button
        @click="$emit('close')"
        class="flex items-center justify-center w-8 h-8 text-xl text-gray-500 transition-colors duration-200 rounded-full hover:bg-red-100 hover:text-red-600"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
          ></path>
        </svg>
      </button>
    </div>
    <div ref="chatContainer" class="flex-1 p-4 space-y-4 overflow-y-auto chatContainer bg-gray-50">
      <div
        v-for="(message, index) in messages"
        :key="index"
        class="flex animate-fadeIn"
        :class="message.sender === 'user' ? 'justify-end' : 'justify-start'"
      >
        <div
          class="max-w-[80%] p-3 rounded-2xl shadow-sm"
          :class="message.sender === 'user' ? 'bg-primary-100 text-gray-800 rounded-tr-none' : 'bg-white text-gray-800 rounded-tl-none'"
        >
          <p class="mb-1 text-xs font-medium" :class="message.sender === 'user' ? 'text-primary-700' : 'text-gray-600'">
            {{ message.sender === 'user' ? $t('You') : '' }}
          </p>
          <Vue3MarkdownIt class="text-sm message-content" :source="message.text" />
        </div>
      </div>
      <div v-if="loading" class="flex justify-start">
        <div class="max-w-[80%] p-3 rounded-2xl rounded-tl-none bg-white shadow-sm">
          <!-- <p class="mb-1 text-xs font-medium text-gray-600">ACasa</p> -->
          <div class="flex space-x-1">
            <div class="w-2 h-2 bg-gray-300 rounded-full animate-bounce"></div>
            <div class="w-2 h-2 bg-gray-300 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
            <div class="w-2 h-2 bg-gray-300 rounded-full animate-bounce" style="animation-delay: 0.4s"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-3 bg-white border-t border-gray-100">
      <div class="flex items-center gap-2 p-1 transition-all border border-gray-200 rounded-lg bg-gray-50 focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-100">
        <input
          v-model="newMessage"
          @keyup.enter="sendMessage"
          type="text"
          :placeholder="$t('Type a message...')"
          class="w-full p-2 text-gray-700 bg-transparent border-none focus:outline-none ring-0 focus:ring-0"
        />
        <button
          @click="sendMessage"
          :disabled="newMessage.trim() === ''"
          :class="{
            'bg-primary-600 hover:bg-primary-700': newMessage.trim() !== '',
            'bg-gray-300 cursor-not-allowed': newMessage.trim() === ''
          }"
          class="flex items-center justify-center p-2 text-white transition-colors duration-200 rounded-lg"
        >
          <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3.5 1.34558C3.58425 1.34558 3.66714 1.36687 3.74096 1.40747L22.2034 11.5618C22.4454 11.6949 22.5337 11.9989 22.4006 12.2409C22.3549 12.324 22.2865 12.3924 22.2034 12.4381L3.74096 22.5924C3.499 22.7255 3.19497 22.6372 3.06189 22.3953C3.02129 22.3214 3 22.2386 3 22.1543V1.84558C3 1.56944 3.22386 1.34558 3.5 1.34558ZM5 4.38249V10.9999H10V12.9999H5V19.6174L18.8499 11.9999L5 4.38249Z"></path></svg>
        </button>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { ref, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import axios from 'axios'
import Vue3MarkdownIt from 'vue3-markdown-it'
import 'github-markdown-css/github-markdown.css'
const URL_API = process.env.VUE_APP_URL_API

const { t } = useI18n()
const messages = ref([])
// const messages = ref([{ text: t('Hello! How can I help you?'), sender: 'acasa' }])
const loading = ref(false)
const newMessage = ref('')
const chatContainer = ref(null)
const threadId = ref(null)

const sendMessage = async () => {
  if (newMessage.value.trim() !== '') {
    const userMessage = newMessage.value
    messages.value.push({ text: userMessage, sender: 'user' })
    newMessage.value = ''
    scrollToBottom()
    loading.value = true

    try {
      const response = await axios.post(URL_API + 'ask-agent', {
        message: userMessage,
        thread_id: threadId.value
      })
      messages.value.push({ text: response.data.message, sender: 'acasa' })
      threadId.value = response.data.thread_id;
    } catch (error) {
      console.error('Error sending message:', error)
      messages.value.push({
        text: t('Sorry, I could not process your request.'),
        sender: 'acasa'
      })
    } finally {
      loading.value = false
      scrollToBottom()
    }
  }
}

const scrollToBottom = () => {
  nextTick(() => {
    chatContainer.value.scrollTop = chatContainer.value.scrollHeight
  })
}

watch(
  messages,
  () => {
    scrollToBottom()
  },
  { deep: true }
)
</script>
  
<style scoped>
.chatContainer::-webkit-scrollbar {
  width: 4px;
}

.chatContainer::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
<style>
.markdown-body {
  box-sizing: border-box;
  min-width: 200px;
  max-width: 980px;
  margin: 0 auto;
  padding: 0;
  font-size: 14px;
}

.message-content p {
  margin-top: 0;
  margin-bottom: 8px;
}

.message-content p:last-child {
  margin-bottom: 0;
}

@media (max-width: 767px) {
  .markdown-body {
    padding: 0;
  }
}
</style>